import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import EmbeddedForm from './embedded-form';
import './embedded-form.scss';
export default function EmbeddedFormsPanel(props) {
    return (_jsxs("div", { className: "embedded-forms-panel", children: [_jsx("header", { className: "embedded-forms-panel__header", children: _jsx("h4", { className: "embedded-forms-panel__title", children: "Embedded Forms" }) }), props.item.embedded_form?.map((form, ind) => (_jsx(EmbeddedForm, { item: props.item, form: form }, ind)))] }));
}
